import './App.css';
import { useState } from 'react';

function App() {
  const [a, setA] = useState('');
  const [b, setB] = useState('');
  const [wyniki, setWyniki] = useState([]);
  const [filtr, setFiltr] = useState('');
  const [trybEdycji, setTrybEdycji] = useState(null);
  const [edytowane, setEdytowane] = useState({ a: '', b: '' });

  const obliczWynik = (aNum, bNum) => {
    const krok1 = (aNum - bNum) * 1000;
    if (krok1 <= 0) return null;
    const logX = Math.log10(krok1);
    const korekta = 0.445;
    const wynik = (logX - korekta) * 100;

    return {
      a: aNum,
      b: bNum,
      krok1: krok1.toFixed(3),
      logX: logX.toFixed(3),
      wynik: wynik.toFixed(2) + '%',
    };
  };

  const dodajWynik = () => {
    const aNum = parseFloat(a.replace(',', '.'));
    const bNum = parseFloat(b.replace(',', '.'));
    if (isNaN(aNum) || isNaN(bNum)) return;

    const wynik = obliczWynik(aNum, bNum);
    if (wynik) setWyniki([...wyniki, wynik]);
  };

  const wyczyscTabele = () => {
    setWyniki([]);
  };

  const usunWiersz = (indexDoUsuniecia) => {
    setWyniki(wyniki.filter((_, i) => i !== indexDoUsuniecia));
  };

  const rozpocznijEdycje = (index) => {
    setTrybEdycji(index);
    const row = wyniki[index];
    setEdytowane({ a: row.a.toString().replace('.', ','), b: row.b.toString().replace('.', ',') });
  };

  const zapiszEdycje = (index) => {
    const aNum = parseFloat(edytowane.a.replace(',', '.'));
    const bNum = parseFloat(edytowane.b.replace(',', '.'));
    if (isNaN(aNum) || isNaN(bNum)) return;

    const wynik = obliczWynik(aNum, bNum);
    if (!wynik) return;

    const noweWyniki = [...wyniki];
    noweWyniki[index] = wynik;
    setWyniki(noweWyniki);
    setTrybEdycji(null);
  };

  const eksportujDoCSV = () => {
    const naglowki = ['Lp.', 'A', 'B', '(A - B) × 1000', 'log₁₀(X)', 'Wynik (%)'];
    const wiersze = wyniki.map((row, index) => [
      index + 1,
      row.a,
      row.b,
      row.krok1,
      row.logX,
      row.wynik,
    ]);
    const csvContent = [naglowki, ...wiersze]
      .map((row) => row.join(';'))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'wyniki_kalkulatora.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const wynikiFiltrowane = wyniki.filter((row) =>
    Object.values(row).some((v) =>
      v.toString().toLowerCase().includes(filtr.toLowerCase())
    )
  );

  return (
    <div className="app container mt-5">
      <div className='my-4' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 className="mb-4">Kalkulator</h3>
        <img src="https://weblives.pl/images/logo/logo.svg" style={{ height: '48px' }}/>
      </div>
      
      <div className="row mb-3">
        <div className="col-lg-3 col-6 my-2">
          <input
            type="text"
            className="form-control"
            placeholder="Wartość A (np. 1,3657)"
            value={a}
            onChange={(e) => setA(e.target.value)}
          />
        </div>
        <div className="col-lg-3 col-6 my-2">
          <input
            type="text"
            className="form-control"
            placeholder="Wartość B (np. 1,3415)"
            value={b}
            onChange={(e) => setB(e.target.value)}
          />
        </div>
        <div className="col my-2">
          <button className="btn btn-primary w-100" onClick={dodajWynik}>
            Oblicz
          </button>
        </div>
        <div className="col my-2">
          <button className="btn btn-danger w-100" onClick={wyczyscTabele}>
            Wyczyść tabelę
          </button>
        </div>
        <div className="col my-2">
          <button
            className="btn btn-success w-100"
            onClick={eksportujDoCSV}
            disabled={wyniki.length === 0}
          >
            Eksportuj do CSV
          </button>
        </div>
      </div>

      {/* ⬅️ FILTR */}
      <div className="row mb-3">
        <div className="col-12">
          <input
            type="text"
            className="form-control"
            placeholder="Szukaj po A, B lub Wyniku..."
            value={filtr}
            onChange={(e) => setFiltr(e.target.value)}
          />
        </div>
      </div>

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Lp.</th>
            <th>A</th>
            <th>B</th>
            <th>(A - B) × 1000</th>
            <th>log₁₀(X)</th>
            <th>Wynik (%)</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {wynikiFiltrowane.map((row, index) => (
            <tr key={index}>
              <td>{index + 1}</td>

              {trybEdycji === index ? (
                <>
                  <td>
                    <input
                      value={edytowane.a}
                      onChange={(e) => setEdytowane({ ...edytowane, a: e.target.value })}
                      className="form-control form-control-sm"
                    />
                  </td>
                  <td>
                    <input
                      value={edytowane.b}
                      onChange={(e) => setEdytowane({ ...edytowane, b: e.target.value })}
                      className="form-control form-control-sm"
                    />
                  </td>
                </>
              ) : (
                <>
                  <td>{row.a}</td>
                  <td>{row.b}</td>
                </>
              )}

              <td>{row.krok1}</td>
              <td>{row.logX}</td>
              <td>{row.wynik}</td>

              <td>
                {trybEdycji === index ? (
                  <>
                    <button
                      className="btn btn-sm btn-success me-1"
                      onClick={() => zapiszEdycje(index)}
                    >
                      Zapisz
                    </button>
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => setTrybEdycji(null)}
                    >
                      Anuluj
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() => rozpocznijEdycje(index)}
                    >
                      Edytuj
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => usunWiersz(index)}
                    >
                      Usuń
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default App;
